import React from "react";
import "./LoadingScreen.css";
import { useConstants } from "../../constant/constantProvider";
import { useSelector } from "react-redux";
import { RBAC_APPS } from "../../constant/rbacConfig";

const LoadingScreen = ({ isLoading = false, loadingText: propLoadingText }) => {
  const { LOADING_PLEASE_WAIT } = useConstants();
  const selectedAgent = useSelector((state) => state.state?.selectedAgent);
  
  if (!isLoading) return null;

  const isDeepInsights = selectedAgent === RBAC_APPS.DEEP_INSIGHTS;
  return (
    <div className="chat-loading-screen-section loader-section">
      <div className="loader-inner-round-section">
        <div className={`spinner-small ${isDeepInsights ? 'deep-insights-spinner' : ''}`}></div>
        <span className="chat-loading-text">
          {propLoadingText || LOADING_PLEASE_WAIT}
        </span>
      </div>
    </div>
  );
};

export default LoadingScreen;
